import Qs from 'query-string';
import ROUTES from 'routes';
import api from './client';

export function login (creds) {
  return api.post(ROUTES.API.IDENTITY_AUTH, formatData(creds)).then((resp) => {
    if (resp.data.user) // it return Acc[] if user has some ;x
      resp.data = resp.data.user;
    return resp;
  });
}

export function inviteMe (accUser) {
  return api({
    url: ROUTES.API.IDENTITY_INVITE_ME,
    method: 'POST',
    data: Qs.stringify(formatData(accUser)),
    headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8' },
  });
}

export function fetchProfile () {
  const req = api.get(ROUTES.API.IDENTITY_INFO);
  req.then(handleApiVersion);
  return req;
}

function handleApiVersion (resp) {
  const apiVer = resp.headers['x-version']?.split('.')[1];
  const appVer = (process.env.VERSION).split('.')[1];
  if (apiVer !== appVer) {
    const style = 'background: red; color: #bada55; padding: 2px 4px; border-radius: 2px';
    const { console } = window;
    if (apiVer < appVer)
      console.warn(`%cServer v${ apiVer } is below client v${ appVer }!`, style);
    else
      console.log(`%cServer v${ apiVer } doesn't match client v${ appVer }!`, style);
  }
}

export function logout () {
  return api.post(ROUTES.API.IDENTITY_LOGOUT);
}

export function requestChangePassword (creds) {
  return api.post(ROUTES.API.IDENTITY_REQUEST_CHANGE_PSWD, formatData(creds));
}

export function changePassword (creds) {
  return api.post(ROUTES.API.IDENTITY_CHANGE_PSWD, formatData(creds));
}

// export function checkChangePswdToken ({ token }) {
//   return api.post(`${ ROUTES.API.IDENTITY_CHECK_CHANGE_PSWD_TOKEN }/${ token }`);
// }

export function activate (creds/*: { token }*/) {
  return api.post(ROUTES.API.IDENTITY_ACTIVATE, formatData(creds));
}

export function activateInvited (creds/*: { token, email, password }*/) {
  return api.post(
    ROUTES.API.IDENTITY_ACTIVATE_INVITED,
    formatData(creds),
  );
}

function formatData (user) {
  if ('email' in user)
    user.email = user.email.toLowerCase();
  return user;
}
